import { AxiosResponse } from 'axios';
import { END_POINT } from '../end-point';
import { getCookie } from '../../lib/cookie';
import { decrypt } from '../../lib/utils/crypto';
import { TMeResponse, TRequestLoginParams, TResponseLogin, TResponseMeData } from '../../types/api';
import { httpService } from '../util/axiosRequests';
import { CommonResponse } from 'types/axios';
import { axiosInstance } from 'apis/axiosConfig';

const verifyAPI = {
  // 휴대전화 인증 요청
  postPhoneAPI: async (data: { phoneNumber: string }) => {
    // console.log('postPhoneAPI 호출');
    try {
      // console.log('휴대전화 인증 요청 : postPhoneAPI data : ', data);
      // JSON 객체로 데이터를 보내야 하므로, 두 번째 인자는 객체 형식이어야 함
      const response = await axiosInstance.post<TMeResponse>(END_POINT.verifyController.postPhone(), data, { withCredentials: true });
      // console.log('휴대전화 인증 요청 : postPhoneAPI response : ', response);
      return response;
    } catch (error) {
      // console.error('postPhoneAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  // 휴대전화 인증 확인
  postPhoneConfirmAPI: async (data: { phoneNumber: string; verificationCode: string }) => {
    // console.log('postPhoneConfirmAPI 호출');
    try {
      // console.log('휴대전화 인증 확인 : postPhoneConfirmAPI data: ', data);
      const response = await axiosInstance.post<TMeResponse>(END_POINT.verifyController.postPhoneConfirm(), data, { withCredentials: true });
      // console.log('휴대전화 인증 확인 : postPhoneConfirmAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('postPhoneConfirmAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 이메일 인증 코드 전송
  postEmailAPI: async (data: { email: string }) => {
    // console.log('postEmailAPI 호출');
    try {
      // console.log('이메일 인증 코드 확인 : postEmailAPI data: ', data);
      const response = await axiosInstance.post<TMeResponse>(END_POINT.verifyController.postEmail(), data, { withCredentials: true });
      // console.log('이메일 인증 코드 확인 : postEmailAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('postEmailAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 이메일에 전송된 인증 코드 확인
  postEmailConfirmAPI: async (data: { email: string; verificationCode: string }) => {
    // console.log('postEmailConfirmAPI 호출');
    try {
      // console.log('이메일에 전송된 인증 코드 확인 : postEmailConfirmAPI data: ', data);
      const response = await axiosInstance.post<TMeResponse>(END_POINT.verifyController.postEmailConfirm(), data, { withCredentials: true });
      // console.log('이메일에 전송된 인증 코드 확인 : postEmailConfirmAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('postEmailConfirmAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  // 비밀번호 재설정 인증 요청API
  postForgetPasswordAPI: async (data: any) => {
    // console.log('비밀번호 재설정 인증 요청API 호출');
    try {
      // console.log('비밀번호 재설정 인증 요청API data: ', data);
      const response = await axiosInstance.post<TMeResponse>(END_POINT.verifyController.postPassword(), data, { withCredentials: true });
      // console.log('비밀번호 재설정 인증 요청API res data: ', response);
      return response;
    } catch (error) {
      // console.error('비밀번호 재설정 인증 요청API 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 비밀번호 재설정 인증 확인 API
  postForgetPasswordConfirmAPI: async (data: any) => {
    // console.log('비밀번호 재설정 인증 확인 API 호출');
    try {
      // console.log('비밀번호 재설정 인증 확인 API data: ', data);
      const response = await axiosInstance.post<any>(END_POINT.verifyController.postPasswordConfirm(), data, { withCredentials: true });
      // console.log('비밀번호 재설정 인증 확인 API res data: ', response);
      return response;
    } catch (error) {
      // console.error('비밀번호 재설정 인증 요확인 API청API 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 비밀번호 재설정 API
  putForgetPasswordChangeAPI: async (data: any) => {
    // console.log('비밀번호 재설정 API 호출');
    try {
      // console.log('비밀번호 재설정 API data: ', data);
      const response = await axiosInstance.put<TMeResponse>(END_POINT.verifyController.putPasswordChange(), data, { withCredentials: true });
      // console.log('비밀번호 재설정 API res data: ', response);
      return response;
    } catch (error) {
      // console.error('비밀번호 재설정 API 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  }
};

export const {
  postPhoneAPI,
  postPhoneConfirmAPI,
  postEmailAPI,
  postEmailConfirmAPI,
  postForgetPasswordAPI,
  postForgetPasswordConfirmAPI,
  putForgetPasswordChangeAPI
} = verifyAPI;
